import { createAction } from 'redux-actions'

import { TOGGLE_SELECT_FILTER, UNSELECT_ALL_FILTERS } from './constants'

export const toggleSelectQuickFilter = createAction(TOGGLE_SELECT_FILTER)
export const unselectAllFilters = createAction(UNSELECT_ALL_FILTERS)
